// Cảng theo UN/LOCODE (TblPortData: CTYCODE · CITY · CTRYCODE · Region).
// PORTS là danh mục mẫu: cảng VN và các POD/cảng chuyển tải hay gặp trong board Mint-P2P / Mint-Rates
// và LOGI-data-dictionary.md (crm-rates-svc §2.3–2.4, job-booking §3.8). Danh mục đủ (~12.900 dòng) đến từ DataSource.
import type { RegionKey } from './regions';
import { matchKey } from './text';

export interface Port {
  /** UN/LOCODE 5 ký tự, vd `VNSGN`. */
  code: string;
  /** Tên thành phố theo TblPortData.CITY (IN HOA, không dấu). */
  name: string;
  /** Mã nước ISO 3166 alpha-2. */
  country: string;
  region: RegionKey;
  /** Tên gọi khác để tìm (tiếng Việt, tên cũ). */
  aliases?: readonly string[];
}

export const PORTS: readonly Port[] = [
  { code: 'VNSGN', name: 'HOCHIMINH CITY', country: 'VN', region: 'ASIA_SOUTH_EASTERN', aliases: ['Hồ Chí Minh', 'Sài Gòn', 'Cát Lái'] },
  { code: 'VNVUT', name: 'VUNG TAU', country: 'VN', region: 'ASIA_SOUTH_EASTERN', aliases: ['Vũng Tàu', 'Cái Mép'] },
  { code: 'VNHPH', name: 'HAIPHONG', country: 'VN', region: 'ASIA_SOUTH_EASTERN', aliases: ['Hải Phòng'] },
  { code: 'VNDAD', name: 'DA NANG', country: 'VN', region: 'ASIA_SOUTH_EASTERN', aliases: ['Đà Nẵng'] },
  { code: 'VNUIH', name: 'QUY NHON', country: 'VN', region: 'ASIA_SOUTH_EASTERN', aliases: ['Quy Nhơn', 'Qui Nhơn'] },
  { code: 'VNDNA', name: 'DONG NAI', country: 'VN', region: 'ASIA_SOUTH_EASTERN', aliases: ['Đồng Nai'] },
  { code: 'KRPUS', name: 'BUSAN', country: 'KR', region: 'ASIA_EASTERN', aliases: ['Pusan'] },
  { code: 'KRINC', name: 'INCHEON', country: 'KR', region: 'ASIA_EASTERN' },
  { code: 'KRKAN', name: 'KWANGYANG', country: 'KR', region: 'ASIA_EASTERN', aliases: ['Gwangyang'] },
  { code: 'JPTYO', name: 'TOKYO', country: 'JP', region: 'ASIA_EASTERN' },
  { code: 'JPYOK', name: 'YOKOHAMA', country: 'JP', region: 'ASIA_EASTERN' },
  { code: 'JPUKB', name: 'KOBE', country: 'JP', region: 'ASIA_EASTERN' },
  { code: 'JPOSA', name: 'OSAKA', country: 'JP', region: 'ASIA_EASTERN' },
  { code: 'JPNGO', name: 'NAGOYA', country: 'JP', region: 'ASIA_EASTERN' },
  { code: 'CNSHA', name: 'SHANGHAI', country: 'CN', region: 'ASIA_EASTERN' },
  { code: 'CNNGB', name: 'NINGBO', country: 'CN', region: 'ASIA_EASTERN' },
  { code: 'CNTAO', name: 'QINGDAO', country: 'CN', region: 'ASIA_EASTERN' },
  { code: 'CNXMN', name: 'XIAMEN', country: 'CN', region: 'ASIA_EASTERN' },
  { code: 'CNSHK', name: 'SHEKOU', country: 'CN', region: 'ASIA_EASTERN' },
  { code: 'CNNSA', name: 'NANSHA', country: 'CN', region: 'ASIA_EASTERN' },
  { code: 'CNTXG', name: 'XINGANG', country: 'CN', region: 'ASIA_EASTERN', aliases: ['Tianjin'] },
  { code: 'CNQGY', name: 'QINGYUAN', country: 'CN', region: 'ASIA_EASTERN' },
  { code: 'TWKHH', name: 'KAOHSIUNG', country: 'TW', region: 'ASIA_EASTERN' },
  { code: 'HKHKG', name: 'HONG KONG', country: 'HK', region: 'ASIA_EASTERN' },
  { code: 'SGSIN', name: 'SINGAPORE', country: 'SG', region: 'ASIA_SOUTH_EASTERN' },
  { code: 'MYPKG', name: 'PORT KELANG', country: 'MY', region: 'ASIA_SOUTH_EASTERN', aliases: ['Port Klang'] },
  { code: 'MYTPP', name: 'TANJUNG PELEPAS', country: 'MY', region: 'ASIA_SOUTH_EASTERN' },
  { code: 'THLCH', name: 'LAEM CHABANG', country: 'TH', region: 'ASIA_SOUTH_EASTERN' },
  { code: 'THBKK', name: 'BANGKOK', country: 'TH', region: 'ASIA_SOUTH_EASTERN' },
  { code: 'PHMNL', name: 'MANILA', country: 'PH', region: 'ASIA_SOUTH_EASTERN' },
  { code: 'INMUN', name: 'MUNDRA', country: 'IN', region: 'ASIA_SOUTHERN' },
  { code: 'AEJEA', name: 'JEBEL ALI', country: 'AE', region: 'MIDDLE_EAST' },
  { code: 'AEUAQ', name: 'UMM AL QUWAIN', country: 'AE', region: 'MIDDLE_EAST' },
  { code: 'AEAJM', name: 'AJMAN', country: 'AE', region: 'MIDDLE_EAST' },
  { code: 'NLRTM', name: 'ROTTERDAM', country: 'NL', region: 'EUROPE_WESTERN' },
  { code: 'BEANR', name: 'ANTWERP', country: 'BE', region: 'EUROPE_WESTERN' },
  { code: 'DEHAM', name: 'HAMBURG', country: 'DE', region: 'EUROPE_WESTERN' },
  { code: 'USLAX', name: 'LOS ANGELES', country: 'US', region: 'NORTHERN_AMERICA' },
  { code: 'USNYC', name: 'NEW YORK', country: 'US', region: 'NORTHERN_AMERICA' },
  { code: 'USSEA', name: 'SEATTLE', country: 'US', region: 'NORTHERN_AMERICA' },
  { code: 'AUSYD', name: 'SYDNEY', country: 'AU', region: 'OCEANIA' },
  { code: 'SXPHI', name: 'PHILIPSBURG', country: 'SX', region: 'CARIBBEAN' },
  { code: 'MQFDF', name: 'FORT DE FRANCE', country: 'MQ', region: 'CARIBBEAN' },
];

const LOCODE = /^[A-Z]{2}[A-Z2-9]{3}$/;

/** Chuẩn hoá mã cảng gõ tay / dữ liệu bẩn (`vnvut `, `VN SGN`) → `VNVUT`; không hợp lệ thì `null`. */
export function normalizeLocode(value: string | null | undefined): string | null {
  if (!value) return null;
  const s = value.toUpperCase().replace(/[\s-]/g, '');
  return LOCODE.test(s) ? s : null;
}

/** Đúng khuôn UN/LOCODE (2 chữ nước + 3 ký tự chữ / số 2–9). */
export function isLocode(value: string): boolean {
  return LOCODE.test(value);
}

/** 3 ký tự sau mã nước — phần dùng trong số báo giá (`VNSGN` → `SGN`). */
export function locodeSuffix(code: string): string {
  return requireLocode(code).slice(2);
}

/** Mã nước của cảng (`KRPUS` → `KR`). */
export function countryOf(code: string): string {
  return requireLocode(code).slice(0, 2);
}

/** Như normalizeLocode nhưng ném lỗi khi mã sai. */
export function requireLocode(code: string): string {
  const c = normalizeLocode(code);
  if (!c) throw new Error(`Mã cảng không hợp lệ: ${code}`);
  return c;
}

const BY_CODE = new Map(PORTS.map((p) => [p.code, p]));

export function findPort(code: string | null | undefined): Port | undefined {
  const c = normalizeLocode(code);
  return c ? BY_CODE.get(c) : undefined;
}

export function isVietnamPort(code: string): boolean {
  return normalizeLocode(code)?.startsWith('VN') ?? false;
}

/** Kê khai hàng hoá trước khi xếp tàu theo nước đến (chip "Có AMS / AFR / ENS" trên board Mint-P2P). */
export type AdvanceFiling = 'AMS' | 'AFR' | 'ENS';

const EU = new Set(['AT', 'BE', 'BG', 'HR', 'CY', 'CZ', 'DK', 'EE', 'FI', 'FR', 'DE', 'GR', 'HU', 'IE', 'IT', 'LV', 'LT', 'LU', 'MT', 'NL', 'PL', 'PT', 'RO', 'SK', 'SI', 'ES', 'SE']);

export function advanceFilingOf(portCode: string): AdvanceFiling | null {
  const country = normalizeLocode(portCode)?.slice(0, 2);
  if (!country) return null;
  if (country === 'US') return 'AMS';
  if (country === 'JP') return 'AFR';
  if (EU.has(country)) return 'ENS';
  return null;
}

/**
 * Tìm cảng: khớp mã (đầu mã), tên, tên gọi khác; không phân biệt hoa/thường và dấu.
 * Thứ tự: trùng mã · đầu mã · đầu tên · chứa trong tên.
 */
export function searchPorts(query: string, ports: readonly Port[] = PORTS): Port[] {
  const q = matchKey(query);
  if (!q) return [...ports];
  const qCode = q.replace(/\s/g, '');
  const scored: Array<[number, Port]> = [];
  for (const p of ports) {
    const names = [p.name, ...(p.aliases ?? [])].map(matchKey);
    let score = -1;
    if (p.code === qCode) score = 0;
    else if (p.code.startsWith(qCode) || p.code.slice(2).startsWith(qCode)) score = 1;
    else if (names.some((n) => n.startsWith(q))) score = 2;
    else if (names.some((n) => n.includes(q))) score = 3;
    if (score >= 0) scored.push([score, p]);
  }
  return scored.sort((a, b) => a[0] - b[0]).map(([, p]) => p);
}
